<template>
  <component
    :is="href ? 'a' : 'button'"
    data-qa="analyses_category_card"
    class="analyses-category-card d-flex flex-column justify-space-between text-decoration-none rounded-lg pa-3"
    :class="{ 'analyses-category-card--button': !href }"
    :href="href || undefined"
    :type="href ? undefined : 'button'"
    @click="onClick"
  >
    <div class="text-subtitle-2 text--text">
      {{ name }}
    </div>

    <img
      :src="icon"
      alt=""
      class="analyses-category-card__icon align-self-end flex-shrink-0"
    >
  </component>
</template>

<script setup lang="ts">
const props = defineProps<{
  name: string
  icon: string
  href: string
}>()

type Emits = {
  (_event: 'click'): void
}

const emit = defineEmits<Emits>()

const onClick = () => {
  if (!props.href) {
    emit('click')
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/variables';

.analyses-category-card {
  background-color: $ui-kit-bg-primary;
  box-sizing: border-box;
  min-height: 160px;

  &--button {
    width: 100%;
    border: 0;
    cursor: pointer;
    text-align: left;
    font: inherit;
    color: inherit;
  }

  &__icon {
    width: 80px;
    height: 80px;
    object-fit: contain;
    pointer-events: none;
    user-select: none;
  }
}
</style>
